module.exports = __webpack_public_path__ + "static/media/Coppa-1998-1.94e4eedf.jpg";